module.exports = __webpack_public_path__ + "img/part4-dIcon15.053fcc47.png";